import { render, staticRenderFns } from "./CmgSustainabilityInfoSection.vue?vue&type=template&id=58d4c655&scoped=true&lang=pug"
import script from "./cmg-sustainability-info-section.ts?vue&type=script&lang=ts&external"
export * from "./cmg-sustainability-info-section.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgSustainabilityInfoSection.vue?vue&type=style&index=0&id=58d4c655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d4c655",
  null
  
)

export default component.exports